import { Partner } from 'types';

export const getPartnerFromSociety = (
  partnerId: string,
  partners: Partner[]
): Partner | undefined => {
  const partner = partners?.find(
    (societyPartner) => societyPartner._id === partnerId
  );
  return partner;
};
